import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@7f-ui/components/skeleton/skeleton';
import { SkeletonCards } from 'src/shared/composites/skeleton-cards';
export function AccommodationDetailSectionLoading() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-3"><Skeleton className="h-5 w-full" /><Skeleton className="h-5 w-11/12" /><Skeleton className="h-5 w-10/12" /><Skeleton className="h-5 w-8/12" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid gap-6 md:gap-12" aria-hidden={true}>{t0}<div className="grid grid-cols-6 gap-4 sm:gap-8"><Skeleton className="col-span-6 aspect-4/3 rounded-xl sm:col-span-3" /><Skeleton className="col-span-3 aspect-4/3 rounded-xl" /><Skeleton className="col-span-3 aspect-4/3 rounded-xl" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function AccommodationTeaserLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="-mx-4 xs:-mx-6 md:-mx-12 lg:-mx-16" aria-hidden={true}><div className="flex gap-4 overflow-hidden px-4 xs:px-6 md:px-12 lg:px-16"><SkeletonCards variant="wide" mobileSize="fixed" count={3} className="min-w-64 flex-1" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function AccommodationImportantNotesLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid gap-5 sm:gap-4" aria-hidden={true}><Skeleton className="h-14 rounded-2xl" /><Skeleton className="h-14 rounded-2xl" /><Skeleton className="h-14 rounded-2xl" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}